import { createContext, useContext, type Dispatch } from "react";
import type { MetricOption, SubjectEntity } from "../../Processing/types";
import type { PlotFormState, PlotAction } from "./plotState";

/**
 * Lightweight context scoped to PlotConfigurator. Replaces the old
 * WidgetBuildContext by exposing the reducer's state + dispatch along
 * with data accessors needed by the step components.
 */
interface PlotContextValue {
  state: PlotFormState;
  dispatch: Dispatch<PlotAction>;
  metrics: MetricOption[];
  getSubjectEntities: (subjectType: string) => SubjectEntity[];
}

const PlotContext = createContext<PlotContextValue | null>(null);

export const PlotContextProvider = PlotContext.Provider;

export function usePlotContext(): PlotContextValue {
  const ctx = useContext(PlotContext);
  if (!ctx) throw new Error("usePlotContext must be used within PlotContextProvider");
  return ctx;
}
